module.exports = __webpack_public_path__ + "static/media/md-document.9d31a249.svg";